import { logger as garnishLogger } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

export const locationSearchLogger = garnishLogger.extend('LOCATION STATE MACHINE');
// garnishLogger.enable('LOCATION STATE MACHINE');
